import {
  CommentOrReplyForm,
  ContextUserType,
  IMessage,
  IMessagesQueryParams,
  Sheet,
  SheetContent,
  useMessageContext,
} from '@ui/components';
import { useReplyRefContext } from '@ui/contexts';
import React from 'react';
import { createPortal } from 'react-dom';

interface Props {
  userType: ContextUserType;
  creator_id: string;
  user_id: string;
  queryParams: IMessagesQueryParams;
  main_post_ref: string;
  community_details: IMessage['community_details'];
  creatorData?: { platform_settings?: { enable_video_uploads?: boolean } };
}
export const ReplyFormPortal = (props: Props) => {
  const { setTargetRef, targetRef, message, setMessage, replyUIVersionNumber } =
    useReplyRefContext();
  const messageState = useMessageContext(props.userType);

  const onDismiss = () => {
    setTargetRef(null);
    setMessage(null);
  };

  if (replyUIVersionNumber === 2 && message) {
    return (
      <CommentOrReplySheet open={Boolean(message)} onDismiss={onDismiss}>
        <CommentOrReplyForm
          key={message.id}
          creator_id={message?.creator_id || messageState.creator_id}
          thread_id={message?.child_thread_id}
          user_id={messageState.user_id}
          contentType="reply"
          userType={props.userType}
          replyTo={message ? { label: message?.user_username, id: message?.user_id } : undefined}
          activateToolbarOnFocus={false}
          onDismiss={onDismiss}
          createThreadIfNotExist
          message_id={message?.id}
          conversation_id={message?.conversation_id}
          queryParam={message?.queryParams || props.queryParams}
          main_post_ref={props?.main_post_ref}
          miscellaneous={message?.miscellaneous}
          community_details={
            props.community_details ||
            (message?.community_details as NonNullable<IMessage['community_details']>)
          }
          creatorData={props.creatorData}
        />
      </CommentOrReplySheet>
    );
  }

  if (targetRef && replyUIVersionNumber === 1) {
    return (
      <Portal targetRef={targetRef}>
        <div>
          <CommentOrReplyForm
            creator_id={message?.creator_id || messageState.creator_id}
            thread_id={message?.child_thread_id}
            user_id={messageState.user_id}
            contentType="reply"
            userType={props.userType}
            replyTo={message ? { label: message?.user_username, id: message?.user_id } : undefined}
            activateToolbarOnFocus={false}
            onDismiss={onDismiss}
            createThreadIfNotExist
            message_id={message?.id}
            conversation_id={message?.conversation_id}
            queryParam={message?.queryParams || props.queryParams}
            main_post_ref={props?.main_post_ref}
            community_details={
              message?.community_details as NonNullable<IMessage['community_details']>
            }
            creatorData={props.creatorData}
          />
        </div>
      </Portal>
    );
  }

  return null;
};

const Portal = ({
  children,
  targetRef,
}: {
  children: React.ReactNode;
  targetRef: HTMLDivElement;
}) => {
  return createPortal(children, targetRef);
};

interface CommentOrReplySheetProps {
  children: React.ReactNode;
  open: boolean;
  onDismiss: () => void;
}
const CommentOrReplySheet = ({ children, open, onDismiss }: CommentOrReplySheetProps) => {
  return (
    <Sheet
      open={open}
      modal={false}
      // onOpenChange={onDismiss}
    >
      <SheetContent
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        className="z-[99999] p-2 m-0 lg:w-[calc(100%-280px)] ml-auto border-none"
        side="bottom"
        closeButtonClassName="hidden">
        <div className="flex flex-row gap-4">
          <div className="space-y-4 max-w-[876px] w-full mx-auto py-4">{children}</div>
          <div className="w-[300px] hidden lg:block"></div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
